document.addEventListener('DOMContentLoaded', function() {
    var collectionUrlElement = document.getElementById('collection-url');
    if (!collectionUrlElement) return;

    // Extract URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    var vendor = urlParams.get('q'); // Get the value of 'q'

    if (vendor) {
        collectionUrlElement.setAttribute('data-vendor', vendor);
    }

    var collectionUrl = collectionUrlElement.getAttribute('data-collection-url');
    
    if (vendor) {
        collectionUrl += '?q=' + encodeURIComponent(vendor);
    }
    
    collectionUrlElement.setAttribute('data-collection-url', collectionUrl);
});


document.addEventListener('DOMContentLoaded', function() {
    var loadMoreButton = document.getElementById('load-more');
    var productGrid = document.getElementById('product-grid');
    var progressBar = document.querySelector('.progress-item');
    var currentPage = 1;
    var isLoading = false;
    
    var totalProducts = parseInt(document.getElementById('total_count').textContent, 10);
    var productsPerPage = parseInt(document.getElementById('productsPerPage').textContent, 10);
    var loadMoreCount = 6; // Always load 6 products per click
    var currentProductsElement = document.getElementById('currentProducts');
    var currentProductsLoaded = parseInt(currentProductsElement.textContent, 10);

    var collectionUrlElement = document.getElementById('collection-url');
    var collectionUrl = collectionUrlElement ? collectionUrlElement.getAttribute('data-collection-url') : window.location.pathname;
    var vendorParam = collectionUrlElement.getAttribute('data-vendor') || ''; // Get the selected vendor

    loadMoreButton.addEventListener('click', function() {
        if (isLoading) return;
        isLoading = true;
        loadMoreButton.innerText = 'Loading...';
        currentPage++;

        var separator = collectionUrl.includes('?') ? '&' : '?';
        var nextPageUrl = `${collectionUrl}${separator}page=${currentPage}`;

        // ✅ If a vendor (brand) is selected, add it to the URL
        if (vendorParam) {
            nextPageUrl += `&q=${encodeURIComponent(vendorParam)}`;
        }

        fetch(nextPageUrl)
            .then(response => {
                if (!response.ok) throw new Error('Error loading page: ' + response.status);
                return response.text();
            })
            .then(data => {
                var parser = new DOMParser();
                var doc = parser.parseFromString(data, 'text/html');
                var newProducts = doc.querySelectorAll('#product-grid > li');

                // Only append the first 6 products
                var productsToAppend = Array.from(newProducts).slice(0, loadMoreCount);

                productsToAppend.forEach(product => {
                    productGrid.appendChild(product);
                });

                currentProductsLoaded += productsToAppend.length;
                currentProductsElement.textContent = currentProductsLoaded;

                if (currentProductsLoaded >= totalProducts) {
                    loadMoreButton.style.display = 'none';
                } else {
                    loadMoreButton.innerText = 'Load More';
                }

                var progressBarWidth = (currentProductsLoaded / totalProducts) * 100;
                progressBar.style.width = progressBarWidth + '%';

                isLoading = false;
            })
            .catch(error => {
                console.error('Error loading more products:', error);
                isLoading = false;
                loadMoreButton.innerText = 'Load More';
            });
    });
});

// Product layout switching
document.addEventListener('DOMContentLoaded', function () {
  const gridButton = document.getElementById('grid-view');
  const listButton = document.getElementById('list-view');
  const productGrid = document.querySelector('.product-grid');

  if (gridButton && listButton && productGrid) {
    gridButton.addEventListener('click', function () {
      productGrid.classList.remove('list-view');
      gridButton.classList.add('active');
      listButton.classList.remove('active');
    });

    listButton.addEventListener('click', function () {
      productGrid.classList.add('list-view');
      listButton.classList.add('active');
      gridButton.classList.remove('active');
    });
  }
});



